import { render, staticRenderFns } from "./EdgeboardTasktypeConfigForm.vue?vue&type=template&id=735c47d1&"
import script from "./EdgeboardTasktypeConfigForm.vue?vue&type=script&lang=js&"
export * from "./EdgeboardTasktypeConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports